/**
 * Created by hernanherreros on 2019-05-03
 */

import { Request } from 'fetchboi'

export const getQuestions = Request.register({
  endpoint: '/questions?CongressSlug=:CongressSlug&offset=:offset&limit=:limit',
  method: 'get',
  useAuthentication: false,
})

export const getAnswers = Request.register({
  endpoint: '/questions/answers?Email=:Email',
  method: 'get',
  useAuthentication: false,
})

export const getQuestion = Request.register({
  endpoint: '/questions/:uuid',
  method: 'get',
  useAuthentication: false,
})

export const answerQuestion = Request.register({
  endpoint: '/questions/answers?',
  method: 'post',
  useAuthentication: false,
})